import { Box, Container } from '@mui/material';

const Report = () => {
	return (
		<>
			<Box component={'main'}>
				<Container maxWidth={'lg'}>
					<h2>Report</h2>
					<div>Coming Soon...</div>
				</Container>
			</Box>
		</>
	);
};

export default Report;
